import filter from "lodash/filter";
import forEach from "lodash/forEach";
import intersection from "lodash/intersection";
import map from "lodash/map";
import getGraphNodeSources from "./nodeOrEdgeSourceDataHandling/getGraphNodeSources";
export default (graphComponentRef, sourceTaskIds, nodesLayoutsRef) => {
    if (!graphComponentRef.current)
        return;
    const nodesToHide = filter(graphComponentRef.current.graph.nodes.toArray(), n => {
        const sources = getGraphNodeSources(n);
        if (intersection(map(sources, "SourceTaskId"), sourceTaskIds).length > 0) {
            forEach(sources, s => {
                nodesLayoutsRef.current[s.NodeId] = n.layout.toRect();
            });
            return true;
        }
        return false;
    });
    forEach(nodesToHide, n => {
        var _a;
        (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph.remove(n);
    });
};
